import { ChecksumTableCell } from "./ChecksumTableCell";

export const useChecksumModalTableColumsSettings = () => {
	return [
		{
			name: "innertext",
			title: "Наименование",
			width: "auto",
			cellHorAlign: "left",
			headHorAlign: "left",
		},
		{
			name: "is_same_check_sum",
			title: "Сравнение контрольных сумм",
			width: "210px",
			cellHorAlign: "center",
			headHorAlign: "left",
			cellJsx: ({ rowObj, clmName, clmObj }) => <ChecksumTableCell rowObj={rowObj} clmName={clmName} clmObj={clmObj} />,
		},
	];
};
